import cx from 'classnames'
import s from './styles.module.css'

export default function Tooltip({
  children,
  text,
  show = false,
  position = 'bottom',
  className = null,
  width = undefined,
  textClassName = null,
}) {
  return (
    <div
      className={cx(
        s.tooltip,
        {
          [s.persist]: show,
        },
        className
      )}>
      {children}
      {text && (
        <span
          className={cx(
            s.tooltiptext,
            {
              [s.top]: position === 'top',
            },
            textClassName
          )}
          style={
            width && {
              width,
              marginLeft: `-${width / 2}px`,
            }
          }>
          {text}
        </span>
      )}
    </div>
  )
}
